<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Ustawienia</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <router-link to="/settings">Ustawienia</router-link>
        </li>
        <li class="active">
          <strong>Nowy</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isMainOpen = !isMainOpen">
            <h5>Ustawienia</h5>
            <span :class="chevronMainClass" class="ibox-toggle"></span>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content" v-show="isMainOpen">
              <div class="form-group">
                <label for="username" class="control-label col-sm-2">
                  Nazwa
                </label>
                <div class="col-sm-10">
                  <input
                    v-model="settingObj.name"
                    name="name"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Nazwa"
                    required="required"
                  />
                  <div v-if="errorsAdminData?.data?.name" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.name[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="username" class="control-label col-sm-2">
                  Wartość
                </label>
                <div class="col-sm-10">
                  <input
                    v-model="settingObj.value"
                    name="value"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Wartość"
                    required="required"
                  />
                  <div v-if="errorsAdminData?.data?.value" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.value[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Opis</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="settingObj.description"
                  />
                  <div v-if="errorsAdminData?.data?.name" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.name[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="hr-line-dashed"></div>

              <div class="form-group">
                <div class="col-sm-4 col-sm-offset-2">
                  <router-link class="btn btn-white" to="/settings">
                    Anuluj
                  </router-link>
                  <button
                    v-if="canAddSetting"
                    @click="create"
                    class="btn btn-primary"
                  >
                    Dodaj
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, watch } from "vue";
import { useStore } from "vuex";
import router from "../../router/router";
import { hasPermission } from "../../permissions";
import { settingPermissionsConst } from "../../constants/settingConstants";

export default {
  name: "SettingCreate",
  mixins: [],
  components: {},
  props: {},

  setup() {
    const settingObj = ref({
      name: "",
      value: "",
      description: "",
    });

    const errorsAdminData = ref();
    const showErrors = ref(false);
    const isMainOpen = ref(true);
    const store = useStore();
    const createSettingData = computed(
      () => store.getters.getCreateSettingData
    );

    const canAddSetting = computed(() =>
      hasPermission(settingPermissionsConst.add)
    );

    const create = () => {
      if (!canAddSetting.value) {
        return;
      }

      showErrors.value = true;
      store.dispatch("createSetting", settingObj.value);
    };

    watch(
      () => createSettingData.value,
      function (newValue) {
        if (newValue.status === 201) {
          router.push({ name: "Settings", path: "/settings" }).then(() => {
            store.dispatch("showToaster", {
              type: "success",
              content: "Nowa zmienna została dodana",
            });
          });
        } else {
          var msg = [];
          for (const [key, value] of Object.entries(newValue.data)) {
            msg.push(key + ": " + value);
          }

          store.dispatch("showToaster", {
            type: "error",
            content: msg[0],
          });
          errorsAdminData.value = newValue;
        }
      }
    );

    return {
      settingObj,
      errorsAdminData,
      showErrors,
      create,
      canAddSetting,
      isMainOpen,
    };
  },
  computed: {
    chevronMainClass() {
      return this.isMainOpen ? "fa fa-chevron-up" : "fa fa-chevron-down";
    },
  },
};
</script>

<style scoped>
.ibox-title {
  cursor: pointer;
  position: relative;
}

.ibox-toggle {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #676a6c;
}
</style>
